import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const GetAvailableOpportunitiesForTeamMembers = createAsyncThunk(
    'marketplace/GetAvailableOpportunitiesForTeamMembers',
    async (buyerUserId: number | undefined, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const url = buyerUserId
            ? `/api/Marketplace/MarketplaceOpportunities/GetAvailableOpportunitiesForTeamMembers?buyerUserId=${buyerUserId}`
            : `/api/Marketplace/MarketplaceOpportunities/GetAvailableOpportunitiesForTeamMembers`;

        try {
            const response = await axios.get(url);

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch opportunity at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch opportunity');
            }

            return {
                availableOpportunitiesForTeamMembers: response.data,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching opportunity.',
                'error'
            );
            throw error;
        }
    }
);
